import script from "./Prescriptions.vue?vue&type=script&setup=true&lang=js"
export * from "./Prescriptions.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__